import { useCanAccessProviderLockedSteps } from '@/hooks';
import { ROUTES } from '@/routes';
import { AppNavigate, AppOutlet } from '@/navigation';

export const ProviderRoute: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const canAccessProviderLockedSteps = useCanAccessProviderLockedSteps();

  return canAccessProviderLockedSteps ? (
    <>{children ?? <AppOutlet />}</>
  ) : (
    <AppNavigate to={ROUTES.dashboard} replace />
  );
};
